import { useMemo } from 'react'

import { useModals, useSetState, useShowModal } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import AdCopyReviewerModal from '@modals/AdCopyReviewerModal'
import CopyLinkModal from '@modals/CopyLinkModal'

import type { CampaignModel, OrderItemModel, ProviderModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showAdCopyReviewerModal: false,
  showCopyLinkModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    AdCopyReviewerModal: {
      closeModal: () => setState({ showAdCopyReviewerModal: false }),
    },
    CopyLinkModal: {
      closeModal: () => setState({ showCopyLinkModal: false }),
    },
  }
  return componentCallbacks[component] || {}
}

const AdCopy = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showAdCopyReviewerModal,
    showCopyLinkModal,
  } = state

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      showAdCopyReviewerModal: (payload: {
        campaign: CampaignModel,
        orderItem: OrderItemModel,
        provider: ProviderModel,
      }) => {
        setModalData('AdCopyReviewerModal', payload)
        setState({ showAdCopyReviewerModal: true })
      },
      showCopyLinkModal: (payload: object) => {
        setModalData('CopyLinkModal', payload)
        setState({ showCopyLinkModal: true })
      },
    },
  }), [])

  useShowModal({
    modalKey: 'AdCopyReviewerModal',
    options: {
      // @ts-expect-error TS2322
      callbacks: pageContext.callbacks,
    },
  })

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <AdCopyReviewerModal
          callbacks={callbacks('AdCopyReviewerModal', setState)}
          showModal={showAdCopyReviewerModal}
        />

        {/*
         // @ts-expect-error TS2741 */}
        <CopyLinkModal
          callbacks={callbacks('CopyLinkModal', setState)}
          showModal={showCopyLinkModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default AdCopy
